module.exports = __webpack_public_path__ + "img/pc-ynhy-logo.a19225f0.png";